import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubListApi = (data) => API.get(`${URL.CLUB_LOAD_URL}`, data)

export const MembershipTypeListApi = (data) => API.get(`${URL.MEMBERSHIP_LIST_TYPE_LIST}`, data)

export const MemberUserListApi = (data) => API.get(`${URL.MEMBER_USER_LIST}`, data)
export const MemberShipListsDropDownApi = (data) =>
    API.post(`${URL.MEMBER_EMAIL_LIST}`, data.body, {
        params: data?.params
    })

export const MembershipSearchMembersApi = (data) =>
    API.post(`${URL.MEMBERSHIP_SEARCH_MEMBERS}`, data)

export const MembershipUserListWithSearchApi = (data) =>
    API.post(`${URL.MEMBERSHIP_USER_LIST_WITH_SEARCH}`, data?.bodyData, {
        params: data?.params
    })
export const MembershipPlansByIdForMemberApi = (Id) =>
    API.get(`${URL.MEMBERSHIP_PLANS_ONE_MEMBER}/${Id}`)

export const MemberShipListApi = (data) => {
    // `${URL.MEMBERSHIP_LIST}?_limit=${data?.params?._limit}&_page=${data?.params?._page}&_sort=${data?.params?._sort}&_order=${data?.params?._order}`
    return API.post(`${URL.MEMBERSHIP_LIST}`, data.bodyData, {
        params: data?.params
    })
}
export const SubMemberMemberShipListApi = (data) => {
    // `${URL.MEMBERSHIP_LIST}?_limit=${data?.params?._limit}&_page=${data?.params?._page}&_sort=${data?.params?._sort}&_order=${data?.params?._order}`
    return API.post(`${URL.SUB_MEMBER_MEMBERSHIP_LIST}`, data?.bodyData)
}
export const MemberShipListOldApi = (data) => {
    // `${URL.MEMBERSHIP_LIST}?_limit=${data?.params?._limit}&_page=${data?.params?._page}&_sort=${data?.params?._sort}&_order=${data?.params?._order}`
    return API.post(
        `${URL.MEMBERSHIP_LIST_OLD}?_limit=${data?.params?._limit}&_page=${data?.params?._page}&_sort=${data?.params?._sort}&_order=${data?.params?._order}`,
        data.bodyData
    )
}
export const PlanListByMemberApi = (data) => {
    return API.post(`${URL.PLAN_LIST_BY_MEMBER}`, data.bodyData, {
        params: data?.params
    })
}

export const MembershipListExportToCsvApi = (data) => {
    return API.get(`${URL.MEMBERSHIP_LIST_EXPORT_TO_CSV}`, data?.params)
}

//?club_id=129&age_type_name=youth
export const ChangeNewsLetterStatusApi = (ID, data) =>
    API.post(`${URL.CHANGE_NEWS_LETTER_STATUS}/${ID}`, data)

export const MembershipShowDateUpdateApi = (data) =>
    API.post(`${URL.MEMBERSHIP_SHOW_DATE_UPDATE}`, data)
export const MembershipJoiningDateUpdateApi = (data) =>
    API.post(`${URL.MEMBERSHIP_JOINING_DATE_UPDATE}`, data)
export const MembershipArchiveUpdateApi = (data) => {
    return API.post(`${URL.UPDATE_MEMBERSHIP_LIST_ARCHIVE_STATUS}`, data)
}

// Test Membership API
export const TestMemberShipListApi = (data) => {
    return API.post(`${URL.TEST_MEMBERSHIP_LIST}`, data.bodyData, {
        params: data?.params
    })
}

export const TestMemberShipListOldApi = (data) => {
    return API.post(
        `${URL.TEST_MEMBERSHIP_LIST_OLD}?_limit=${data?.params?._limit}&_page=${data?.params?._page}&_sort=${data?.params?._sort}&_order=${data?.params?._order}`,
        data.bodyData
    )
}

export const TestSubMemberMemberShipListApi = (data) => {
    return API.post(`${URL.TEST_SUB_MEMBER_MEMBERSHIP_LIST}`, data?.bodyData)
}

export const TestPlanListByMemberApi = (data) => {
    return API.post(`${URL.TEST_PLAN_LIST_BY_MEMBER}`, data.bodyData, {
        params: data?.params
    })
}

export const TestMembershipShowDateUpdateApi = (data) =>
    API.patch(`${URL.TEST_MEMBERSHIP_SHOW_DATE_UPDATE}/${data.master_membership_order_id}`, {
        user_id: data.user_id,
        expires_on: data.expires_on
    })

export const TestMembershipSearchMembersApi = (data) =>
    API.post(`${URL.TEST_MEMBERSHIP_SEARCH_MEMBERS}`, data)

export const TestMembershipArchiveUpdateApi = (data) => {
    return API.post(`${URL.TEST_UPDATE_MEMBERSHIP_LIST_ARCHIVE_STATUS}`, data)
}
